import React from 'react'
import ReactDOM from 'react-dom/client'
import { NavContextProvider } from './contexts/nav-context'
import AppRouter from './router/app-router'
import './style/index.css'

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
	<React.StrictMode>
		<NavContextProvider>
			<AppRouter />
		</NavContextProvider>
	</React.StrictMode>
)
